import dayjs from "dayjs";
import * as Xlsx from "xlsx";
import { sanitizeExcelCell } from "@/shared/utils/excel";
import { getPayments, type PaymentListParams } from "../services/payments.api";
import type { PaymentRecord } from "../types/payments.types";
import { paymentMethodLabels } from "./payments.utils";

const EXPORT_PAGE_SIZE = 100;

export async function fetchAllPayments(
	params: Omit<PaymentListParams, "page" | "limit">
): Promise<PaymentRecord[]> {
	const payments: PaymentRecord[] = [];
	let page = 1;

	while (true) {
		const response = await getPayments({ ...params, page, limit: EXPORT_PAGE_SIZE });
		payments.push(...response.items);
		if (
			payments.length >= (response.meta?.total ?? payments.length) ||
			response.items.length === 0
		) {
			break;
		}
		page += 1;
	}

	return payments;
}

export async function exportPaymentsToExcel(
	params: Omit<PaymentListParams, "page" | "limit">
): Promise<number> {
	const payments = await fetchAllPayments(params);

	const rows = payments.map((payment, index) => ({
		"№": index + 1,
		"Mijoz F.I.Sh.": sanitizeExcelCell(payment.clientName),
		Summa: payment.amountUzs,
		"To'lov usuli": paymentMethodLabels[payment.paymentMethod],
		Sana: dayjs(payment.paymentDate).format("DD.MM.YYYY"),
		"Kim qabul qildi": sanitizeExcelCell(payment.receivedBy),
		Izoh: sanitizeExcelCell(payment.note || ""),
		"Qaytarilgan summa": payment.refundedAmount > 0 ? payment.refundedAmount : "",
		Holat:
			payment.refundedAmount <= 0
				? ""
				: payment.refundedAmount >= payment.amountUzs
					? "To'liq qaytarilgan"
					: "Qisman qaytarilgan",
	}));

	const worksheet = Xlsx.utils.json_to_sheet(rows);
	worksheet["!cols"] = [
		{ wch: 5 },
		{ wch: 28 },
		{ wch: 16 },
		{ wch: 14 },
		{ wch: 14 },
		{ wch: 22 },
		{ wch: 30 },
		{ wch: 16 },
		{ wch: 18 },
	];

	const workbook = Xlsx.utils.book_new();
	Xlsx.utils.book_append_sheet(workbook, worksheet, "To'lovlar");

	const fileName = `tolovlar_${new Date().toISOString().split("T")[0]}.xlsx`;
	Xlsx.writeFile(workbook, fileName);

	return payments.length;
}
